import registerModulesWithRouter from 'src/config/AccessControl/registerModulesWithRouter';
import OrderModules from 'src/content/management/Order/module';
import ProductionOrderModules from 'src/content/management/ProductionOrders/module';
import VendorOrderModules from 'src/content/management/VendorOrders/module';

const ordersRoutes = [
  registerModulesWithRouter(OrderModules),
  registerModulesWithRouter(ProductionOrderModules),
  registerModulesWithRouter(VendorOrderModules)
];

export default ordersRoutes;
